const SIXTY_SECONDS = 60_000;
const FIVE_SECONDS = 5_000;
const TEN_SECONDS = 10_000;

// Defaults
export const POLLING_INTERVAL = SIXTY_SECONDS;
export const PAGE_WIDGET_POLLING_INTERVAL = FIVE_SECONDS;
export const MARKETS_UPDATES_INTERVAL = FIVE_SECONDS;
export const DOCUMENT_HIDDEN_MARKETS_UPDATES_INTERVAL = SIXTY_SECONDS;
export const BET_SLIP_AUTO_DISMISS_DELAY = TEN_SECONDS;
export const PROMOTION_ALERT_DISMISS_DELAY = FIVE_SECONDS;

export const DROPDOWN_HEIGHT_ADJUST = 40;
